import { WarningCircle } from "@phosphor-icons/react";
import ReactCountryFlag from "react-country-flag";

import { Tag } from "common/components/ui/Tag";

export default function ProxyLocationTag({
  location,
  isValid,
  size,
}: {
  location: { name: string; countryCode: string };
  isValid: boolean;
  size: "sm" | "md";
}) {
  if (isValid) {
    if (location) {
      return (
        <Tag
          size={size}
          leftIcon={<ReactCountryFlag countryCode={location.countryCode} />}
          variant="tertiary"
        >
          {location.name}
        </Tag>
      );
    }
    return (
      <Tag size={size} variant="tertiary">
        Unknown location
      </Tag>
    );
  }
  return (
    <Tag
      size={size}
      variant="danger"
      leftIcon={<WarningCircle weight="fill" />}
    >
      Invalid
    </Tag>
  );
}
